import { useState } from 'react';

interface AssetLogoProps {
  symbol: string; // Full symbol like "xyz:XYZ100" or "BTC"
  baseAsset: string; // Base asset like "XYZ100" or "BTC"
  size?: number; // Size in pixels (default 32)
  className?: string;
}

export function AssetLogo({ symbol, baseAsset, size = 32, className = '' }: AssetLogoProps) {
  const [imageError, setImageError] = useState(false);

  // Try to load logo from Hyperliquid CDN
  // For HIP-3: https://app.hyperliquid.xyz/coins/xyz:XYZ100.svg
  // For native: https://app.hyperliquid.xyz/coins/BTC.svg
  const logoUrl = `https://app.hyperliquid.xyz/coins/${symbol}.svg`;

  if (imageError) {
    // Fallback: Blue square with first 2 letters
    const fontSize = Math.floor(size / 2.67);
    return (
      <div
        className={`rounded bg-[#2962ff] flex items-center justify-center text-white font-bold ${className}`}
        style={{ width: `${size}px`, height: `${size}px`, fontSize: `${fontSize}px` }}
      >
        {baseAsset.slice(0, 2).toUpperCase()}
      </div>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={baseAsset}
      className={`rounded ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
      onError={() => setImageError(true)}
    />
  );
}
